import api from "../../http";

export default class ApiIndexAboutUs {
  static async getApiIndexAboutUs(url) {
    return api.get(url)
  }
}